import PropTypes from 'prop-types';
import React from 'react';
import { Redirect, Route, useLocation } from 'react-router-dom';
import { routes } from '@/app/routes';
import { VerticalBar } from '@/dashboard/components/vertical-bar/vertical-bar';

/**
 * This component is a wrapper aroud Route component. Will redirect to login page if user not
 * authenticated
 *
 * @param {object} param
 * @param {bool} param.isAuthenticated is logged in or not
 * @param {element | func | string} param.component
 * @param {string} param.path e.g.: /login
 */
export function AuthenticatedRoute({
  isAuthenticated,
  render,
  component,
  path,
  exact,
}) {
  // TODO: re-examine need for BrowserRouter provide granted we have these hooks
  const location = useLocation();
  const nextLocation = location.state?.from || path;

  return (
    <div className="flex h-full w-full">
      <VerticalBar />
      <div className="flex-1">
        {isAuthenticated ? (
          <Route
            path={nextLocation}
            component={component}
            render={render}
            exact={exact}
          />
        ) : (
          <Redirect
            to={{
              pathname: routes.LOGIN,
              // sets state for the /login route only
              state: { from: location.pathname },
            }}
          />
        )}
      </div>
    </div>
  );
}

AuthenticatedRoute.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired,
  component: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
    PropTypes.string,
  ]),
};
